module.exports = __webpack_public_path__ + "images/bug_wine_red_size_5_618d1818036d131c5b24eafef2bafff9.png";